import type { ObjectId } from '@racemap/sdk/schema/base';
import { OneSecondInMillis } from '@racemap/utilities/consts/time';
import { Card, Space, Typography } from 'antd';
import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInterval } from 'src/lib/customHooks/useInterval';
import { useIsAdmin } from 'src/lib/customHooks/useIsAdmin';
import { useStore } from '../../store/reducers';
import { Devider } from '../BasicComponents/Devider/Devider';
import { UserChooser } from '../BasicComponents/UserChooser';
import { TemplatesList } from './TemplatesList';

const { Text } = Typography;

export const AllTemplatesList: FC = () => {
  const isAdmin = useIsAdmin();
  const { removeTemplate, loadData, setImpersonatedUserId } = useStore(
    (s) => s.messageTemplates.actions,
  );
  const templates = useStore((s) => s.messageTemplates.items);
  const isLoading = useStore((s) => s.messageTemplates.isLoading);
  const impersonatedUserId = useStore((s) => s.messageTemplates.impersonatedUserId);
  const navigate = useNavigate();
  const templatesArray = Array.from(templates.values());

  useInterval(async () => {
    loadData();
  }, 10 * OneSecondInMillis);

  const handleTemplateRemove = (id: ObjectId) => {
    removeTemplate(id);
  };

  const handleTemplateAddClick = () => {
    navigate('/admin/message-templates/new');
  };

  const publicTemplates = templatesArray.filter((t) => t.isPublic);
  const privateTemplates = templatesArray.filter((t) => !t.isPublic);

  return (
    <Card
      title="Message Template"
      extra={
        isAdmin && (
          <Space>
            <Text strong>Impersonate User:</Text>
            <UserChooser value={impersonatedUserId} onChange={setImpersonatedUserId} />
          </Space>
        )
      }
    >
      <Space orientation="vertical" size={40} style={{ width: '100%' }}>
        <div>
          <TemplatesList
            templates={privateTemplates}
            isLoading={isLoading}
            onTemplateRemove={handleTemplateRemove}
            onAddTemplateClick={handleTemplateAddClick}
            title="Your templates:"
          />
        </div>
        <Devider />
        <div>
          <TemplatesList
            templates={publicTemplates}
            isLoading={isLoading}
            showAddButton={false}
            showExportButton={false}
            onTemplateRemove={handleTemplateRemove}
            title="Public templates:"
          />
        </div>
      </Space>
    </Card>
  );
};
